import { Injectable, UseFilters } from '@nestjs/common';
import { Repository } from 'typeorm';
import { Skills } from './skills.entity';
import { SkillsDTO } from './dto/skills.dto';
import { InjectRepository } from '@nestjs/typeorm';
import { SkillsAdapter } from './dto/skills.adapter';
import { SkillsResponseModel, AllSkillsResponseModel } from '@gtpl/shared-models/hrms';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { SkillsRequest } from './dto/skills.request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';

@Injectable()
export class SkillsService {

    constructor(
      private logService:LogsService,

        @InjectRepository(Skills)
        private skillsRepository: Repository<Skills>,
        private skillsAdapter: SkillsAdapter,
    ){}

    async getSkillsWithoutRelations(skills: string): Promise<Skills>{
        const skillsResponse = await  this.skillsRepository.findOne({
            where: {skills: skills},
        });
        if(skillsResponse){
            return skillsResponse;
        }else {
            return null;
        }
    }

    async createSkill(skillsDTO: SkillsDTO, isUpdate: boolean): Promise<SkillsResponseModel>{
        try{
            if(!isUpdate){
                const skillsEntity = await this.getSkillsWithoutRelations(skillsDTO.skills);
                if(skillsEntity){
                    throw new ErrorResponse(11104, 'skill already exists');
                }
            }else {
                const skillsEntity = await this.getSkillsWithoutRelations(skillsDTO.skills);
                if(skillsEntity){
                    if(skillsEntity.skillsId != skillsDTO.skillsId){
                        throw new ErrorResponse(11104, 'skill already exists')
                    }
                }
            }
            const convertedEntity: Skills = this.skillsAdapter.convertDtoToEntity(skillsDTO, isUpdate);
            const savedEntity: Skills = await this.skillsRepository.save(convertedEntity);
            const savedDto: SkillsDTO = this.skillsAdapter.convertEntityToDto(convertedEntity);
            if(savedDto){
                const response = new SkillsResponseModel(true, 1, isUpdate? 'Skill Updated Successfully' : 'Skill Created Successfully');
                const name=isUpdate?'updated':'created'
            
                const newLogDto = new LogsDto(1,name, 'Skills', savedDto.skillsId, true, '',savedDto.createdUser)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            }else{
                throw new ErrorResponse(11106, 'Skill saved but issue while transforming it into DTO');
            }
        }catch(error){
            throw error;
        }
    }

    async getAllSkills() : Promise<AllSkillsResponseModel>{
        try{
            const skillsDtos: SkillsDTO[] = [];
            const skillsEntities: Skills[] = await this.skillsRepository.find({order: {skills: 'ASC'}});
            if(skillsEntities){
                skillsEntities.forEach(Entity => {
                    const convertedDto: Skills = this.skillsAdapter.convertEntityToDto(Entity);
                    skillsDtos.push(convertedDto);
                });
                const response = new AllSkillsResponseModel(true, 1, 'Skills Retrieved Successfully', skillsDtos);
                const newLogDto = new LogsDto(1,'view', 'Skills', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                return response;
            }else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        }catch(err){
            throw err;
        }
    }

    async getAllActiveSkills() : Promise<AllSkillsResponseModel>{
        try{
            const skillsDtos: SkillsDTO[] = [];
            const skillsEntities: Skills[] = await this.skillsRepository.find({order: {skills: 'ASC'}, where: {isActive: true},});
            if(skillsEntities){
                skillsEntities.forEach(Entity => {
                    const convertedEntity: Skills = this.skillsAdapter.convertEntityToDto(Entity);
                    skillsDtos.push(convertedEntity);
                });
                const response = new AllSkillsResponseModel(true, 11108, 'Active Loan Categories Retrieved Successfully', skillsDtos);
                return response;
            }else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        }catch(err){
            throw err;
        }
    }

    async getSkillsById(skillsId: number): Promise<Skills>{
        const response = await this.skillsRepository.findOne({
            where: {skillsId: skillsId},
        });
        if(response){
            return response;
        }else{
            return null;
        }
    }

    async activateOrDeactivateSkill(skillReq: SkillsRequest): Promise<SkillsResponseModel>{
        try{
            const skillExists = await this.getSkillsById(skillReq.skillsId);
            if(skillExists){
                if(skillReq.versionFlag != skillExists.versionFlag){
                    throw new ErrorResponse(10113, 'Someone updated the current skill information. Refresh and try again');
                }else{
                    const skillStatus = await this.skillsRepository.update(
                        {skillsId: skillReq.skillsId},
                        {isActive: skillReq.isActive, updatedUser: skillReq.updatedUser}
                    );
                    if(skillExists.isActive){
                        if(skillStatus.affected){
                            const skillResponse: SkillsResponseModel = new SkillsResponseModel(true, 10115, 'skill is de-activated successfully');
                            return skillResponse;
                        }else{
                            throw new ErrorResponse(10111, ' skill is already de-activated');
                        }
                    }else{
                        if(skillStatus.affected){
                            const skillResponse: SkillsResponseModel = new SkillsResponseModel(true, 10114, 'skill is activated successfully');
                            return skillResponse;
                        }else{
                            throw new ErrorResponse(10112, 'skill is already activated');
                        }
                    }
                }
            }else{
                throw new ErrorResponse(99998, 'No Records Found');
            }
        }catch(err){
            throw err;
        }
    }
}
